import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AcompanhamentoDespesaAdministrativaMainComponent } from './acompanhamento-despesa-administrativa-main/acompanhamento-despesa-administrativa-main.component';
import { GlobalModule } from 'src/app/global/global.module';

@NgModule({
  declarations: [AcompanhamentoDespesaAdministrativaMainComponent],
  imports: [CommonModule, GlobalModule],
})
export class AcompanhamentoDespesaAdministrativaModule {}
